import { MERCEDES_IMAGE } from "assets";

export const data = [
  {
    title: "Civilian Vehicle Armoring",
    images: [MERCEDES_IMAGE, MERCEDES_IMAGE, MERCEDES_IMAGE],
    heroText:
      "HSTC - specialize in the armoring of various OEM types of civilian and luxury vehicles to the International Standard NIJ as per Ballistic Level Chart. All our vehicles are installed with Internationally approved Ballistic Glass to suit the protection level",
    vehicleTypes: [
      "Luxury Sedans",
      "Single Cab, Super Cab and Double Cab LDV’s",
      "SUV’s",
    ],
  },
  {
    title: "Security Vehicle Conversions & Armoring",
    images: [],
    vehicleTypes: [],
  },
  { title: "Body Armor Solutions", images: [], vehicleTypes: [] },
  { title: "Cash In Transit Vehicle (CIT )", images: [], vehicleTypes: [] },
];
